import React from "react";

function WeatherCard() {
  return (
    <div className="card">
      <div className="card-body">
        <div data-simplebar>
          <div className="vstack overflow-hidden">
            <div className="d-flex">
              <div className="avatar-sm">
                <div className="avatar-title bg-light rounded-circle text-primary h1">
                  <i className="fas fa-sun"></i>
                </div>
              </div>
              <div className="mt-1 flex-grow-1">
                <h6 className="mb-1 font-size-15 ms-3">Seoul</h6>
                <h6 className="text-muted mb-0 ms-3">
                  구름 한 점 없는 맑은 하늘
                </h6>
              </div>

              <div className="d-flex mt-1 ms-2">
                {/* 온도 */}
                <div className="d-flex flex-column align-items-center me-3">
                  <i className="mdi mdi-thermometer fs-4 mb-0"></i>
                  <span className="fs-6 mt-0">3º</span>
                </div>
                {/* 습도 */}
                <div className="d-flex flex-column align-items-center">
                  <i className="mdi mdi-water-percent fs-4 mb-0"></i>
                  <span className="fs-6 mt-0">48%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WeatherCard;